/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/absent_over_time.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns `1` if the range vector has no elements, and `0` otherwise.
 *
 * @example
 * absent_over_time(nonexistent_metric[5m])
 */
const definition: PromqlFunctionDefinition = {
  type: 'within_series',
  name: 'absent_over_time',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'range_vector',
          optional: false,
          description: 'Range vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
